var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCcGooglepay = function SvgCcGooglepay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 35 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#D9D9D9",
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3C4043",
    fillRule: "evenodd",
    d: "M16.53 15.758v-3.021h1.56c.638 0 1.177-.214 1.617-.636l.106-.107a2.175 2.175 0 0 0-.106-3.045A2.225 2.225 0 0 0 18.09 8.3h-2.503v7.457h.944Zm0-3.937V9.217h1.583c.34 0 .663.13.903.368.51.5.522 1.332.03 1.85-.241.255-.581.398-.933.386H16.53Zm7.685-.767c-.405-.375-.956-.565-1.653-.565-.897 0-1.571.333-2.017.993l.833.53c.305-.452.72-.678 1.248-.678.334 0 .657.125.909.35.246.215.387.524.387.85v.22c-.364-.201-.821-.308-1.384-.308-.656 0-1.184.154-1.576.47-.393.315-.593.73-.593 1.26-.011.482.194.94.557 1.249.37.333.839.5 1.39.5.65 0 1.166-.292 1.559-.875h.04v.708h.903v-3.146c0-.66-.199-1.183-.603-1.558Zm-2.562 3.764a.776.776 0 0 1-.31-.624c0-.28.129-.512.38-.696.259-.184.581-.28.962-.28.528-.005.938.114 1.231.351 0 .405-.158.756-.469 1.053a1.489 1.489 0 0 1-1.06.446 1.142 1.142 0 0 1-.734-.25ZM26.847 18 30 10.656h-1.026l-1.46 3.663h-.017l-1.494-3.663h-1.026l2.069 4.775L25.874 18h.973Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M13.272 12.083c0-.292-.023-.583-.07-.868h-3.98v1.647h2.28a1.984 1.984 0 0 1-.844 1.302v1.07h1.36c.797-.743 1.254-1.843 1.254-3.151Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M9.222 16.27c1.137 0 2.098-.381 2.796-1.035l-1.36-1.07c-.38.26-.867.41-1.436.41-1.102 0-2.034-.756-2.368-1.767H5.453v1.106a4.21 4.21 0 0 0 3.769 2.355Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M6.854 12.808a2.62 2.62 0 0 1 0-1.641v-1.1H5.453a4.3 4.3 0 0 0 0 3.841l1.401-1.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M9.222 9.4a2.254 2.254 0 0 1 1.618.643l1.207-1.225a4.042 4.042 0 0 0-2.825-1.112 4.215 4.215 0 0 0-3.769 2.36l1.4 1.107c.335-1.017 1.267-1.772 2.369-1.772Z"
  })));
};
export default SvgCcGooglepay;